import React from "react";
import { createRoot } from "react-dom/client";
import { Provider as ReduxProvider } from "react-redux";
import { ApolloProvider } from "@apollo/client";
import store from "./reducers";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import "./assets/css/app.css";

import apolloClient from "./utils/apolloClient";
import App from "./App";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
    <ApolloProvider client={apolloClient}>
        <ReduxProvider store={store}>
            <App />
        </ReduxProvider>
    </ApolloProvider>
);
